export function tab(_ctx) {
    return {};
}
